import { render, staticRenderFns } from "./bank-length.vue?vue&type=template&id=463b4100"
import script from "./bank-length.vue?vue&type=script&lang=js"
export * from "./bank-length.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports